// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eff39eb4","239":"085d365f","453":"ef8b888e","455":"a492f73c"}[chunkId] + ".chunk.js";
};